if (typeof isNotEmpty !== 'function')
{
    function isNotEmpty(value)
    {
        if (value == null) return false;
        if (typeof value === 'string' || Array.isArray(value))
        {
            return value.length > 0;
        }
        if (typeof value === 'object')
        {
            if (value instanceof Element) return true;
            return Object.keys(value).length > 0;
        }
        return true;
    }
}
 
const viewMoreBtn = document.querySelector('a.view-more');
 
const ulFragnance = document.querySelector('ul.fragnance.full-row');
 
if( isNotEmpty( viewMoreBtn ) && isNotEmpty( ulFragnance ) )
{
    viewMoreBtn.addEventListener('click', function()
    {
        const isAll = viewMoreBtn.classList.toggle('all');
        ulFragnance.classList.toggle('show-all');
        viewMoreBtn.innerHTML = isAll ? 'VIEW LESS -' : 'VIEW MORE +';
    }); 
}

function checkIfThumbnailsBtnIsReady() 
{
    if(window.innerWidth < 768)
    {
        let found = false;
        let attempts = 0;
        const maxAttempts = 15;
        const intervalTime = 150;

        let interval = setInterval(() => 
        {
            if (!found) 
            {
                const element = document.querySelector('#collection input#desktop-layout-thumbnails');
                if (element) 
                {
                    clearInterval(interval);
                    found = true;
                    element.click();
                    
                }
            }
            if (attempts >= maxAttempts) 
            {
                clearInterval(interval);
            }
            attempts++;
        }, intervalTime);
    }
}

checkIfThumbnailsBtnIsReady();